import type { Dispatch, SetStateAction } from 'react'

import { ShotlistsService } from '@/services/shotlist.service'

import { PLATFORMS_CODES } from '@/constants/languages'
import type {
	ISelectedPlatform,
	TPlatformValue
} from '@/types/uploadForm.interface'

export const addPlatform = async (
	taskId: string,
	value: TPlatformValue,
	setSelectedPlatformList: Dispatch<SetStateAction<ISelectedPlatform[]>>,
	setSelectedPlatform: Dispatch<SetStateAction<TPlatformValue | null>>,
	selectedPlatformList: ISelectedPlatform[]
) => {
	const shotlist = await ShotlistsService.getShotlist(taskId)

	const shotlistLanguages = [
		shotlist?.original?.language,
		...(shotlist?.translations?.map(tran => tran.language) || [])
	]

	setSelectedPlatformList(prev => {
		if (prev.some(p => p.value === value)) return prev

		return [
			...prev,
			shotlistLanguages.includes(PLATFORMS_CODES[value])
				? {
						value,
						headerState: 'done',
						result: 'translation',
						autoFilling: selectedPlatformList.length >= 1
				  }
				: {
						value,
						headerState: 'idle',
						autoFilling: selectedPlatformList.length >= 1
				  }
		]
	})

	setSelectedPlatform(value)
}
